<template>
    <div class="tabBox flex-1 flex flex-v">
        <ul class="tab-title">
            <li @click="selected('project')" :class="{on: tabData.onTab === 'project'}">
                项目
            </li>
            <li @click="selected('card')" :class="{on: tabData.onTab === 'card'}">
                卡项
            </li>
            <li @click="selected('goods')" :class="{on: tabData.onTab === 'goods'}">
            产品
            </li>
        </ul>
        <div class="searchForm">
            <el-input :placeholder="tabData.searchPlaceholder" v-model="searchValue" @keypress.native="searchKeyUpEvent">
                <el-button slot="append" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-input>
        </div>
        <ul class="searchData flex-1" ref="searchData">
            <div v-for="(item, i) in searchData" :key="i">
                <li class="b" v-if="item.c_name">{{item.c_name}}&nbsp;</li>
                <li class="pro" v-for="(pro, k) in item.pro_list" :key="k" @click="selectPro(pro)">
                    <span class="pro-title">{{pro.pro_name}}</span>
                    <span class="price">{{parseFloat(pro.price).toFixed(2)}}</span>
                </li>
            </div>
        </ul>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "ProSelect",
        data: () => ({
            searchValue: "",
            tabData: {
                onTab: "project",
                searchPlaceholder: "单价/项目名称首字母",
            },
            searchData: [],
        }),
        mounted: function(){
            this.search();
        },
        watch: {
            "tabData.onTab": function (newData) {
                if(newData == "project"){
                    this.tabData.searchPlaceholder = "单价/项目名称";
                } else if(newData == "goods") {
                    this.tabData.searchPlaceholder = "价格/商品名称";
                } else if(newData == "card") {
                    this.tabData.searchPlaceholder = "单价/次卡名称";
                }

                this.search();
            },
            "searchData": function () {
                this.$nextTick(function () {
                    obj.unScrollbar(this.$refs["searchData"]);
                    obj.scrollbar(this.$refs["searchData"]);
                });
            },
            "searchValue": function (data) {
                if(data === "" || data === null)
                    this.search();
            }
        },
        methods: {
            selected: function (objName) {
                this.tabData.onTab = objName;
            },
            search: function () {
                let apiUrl = "";
                if(this.tabData.onTab === "project")
                    apiUrl = "cash/search_product";
                else if(this.tabData.onTab === "goods")
                    apiUrl = "cash/search_goods";
                else if(this.tabData.onTab === "card")
                    apiUrl = "cash/search_card";

                this.searchData = [];
                obj.postData(apiUrl, {keyword: this.searchValue}, function (res) {
                    if(res.errcode === 0){
                        this.searchData = res.data;
                    }
                }.bind(this));
            },
            selectPro: function (item) {
                let res = {
                    proType: this.tabData.onTab,
                    proData: item
                };
                this.$emit("selected", res);
            },
            searchKeyUpEvent: function (e) {
                if(e.charCode === 13){
                    this.search();
                }
            }
        }
    }
</script>

<style scoped>
    .tabBox{
        height: 100%;
        background-color: #ffffff;
        position: relative;
    }
    .tabBox .tab-title{
        cursor: pointer;
        margin: 16px 16px;
        border-bottom: 1px solid #ebedf0;
        height: 34px;
    }
    .tabBox .tab-title>li{
        display: inline-block;
        position: relative;
        font-size: 14px;
        width: 90px;
        height: 33px;
        line-height: 33px;
        text-align: center;
        background: #f7f8fa;
        border: 1px solid #ebedf0;
        border-left: none;
    }
    .tabBox .tab-title>li.on{
        background: #ffffff;
        border-bottom-color: transparent;
    }
    .tabBox .tab-title>li:first-child{
        border-top-left-radius: 3px;
        border-left: 1px solid #ebedf0;
    }
    .tabBox .tab-title>li:last-child{
        border-top-right-radius: 3px;
    }

    .tabBox .tab-title>li>.onIcon{
        position: absolute;
        width: 18px;
        height: 5px;
        left: 26px;
        bottom: -10px;
        background: #fc0d1b;
        border-radius: 3px;
    }
    .searchForm{
        padding-left: 16px;
        padding-right: 16px;
        height: 40px;
        padding-bottom: 16px;
    }
    .searchData{
        overflow: hidden;
        width: 100%;
        padding-bottom: 20px;
    }
    .searchData li{
        display: block;
        padding: 5px 20px;
        line-height: 22px;
        position: relative;
    }
    .searchData li.b{

    }
    .searchData li.pro:hover{
        background: #F5F7FA;
        cursor: pointer;
    }
    .searchData li>span.pro-title{
        display: inline-block;
        width: 270px;
        vertical-align: text-top;
    }
    .searchData li>span.price{
        display: inline-block;
        width: 60px;
        vertical-align: text-top;
        text-align: right;
        /*float: right;*/
    }
    .searchData li.b:before{
        content: " ";
        display: inline-block;
        vertical-align: text-top;
        width: 4px;
        height: 15px;
        background-color: #0f9cf3;
        border-radius: 2px;
        margin-right: 6px;
    }
</style>
